import './UserInfo.scss';
import Component from './UserInfo.js';
export default Component;
